export function CustomLoadingScreen() {
}
CustomLoadingScreen.prototype.displayLoadingUI = function() {
};//loading start
CustomLoadingScreen.prototype.hideLoadingUI = function() {
};//loading end